import { useMemo } from 'react';
import useSessionPerformanceParams from './useSessionPerformanceParams';
import { SESSION_FILTERS, SESSION_FILTERS_RANGE } from 'config';
import { calculateOverallScore } from 'components/maps/utils';

const useFilteredSessionReports = (reports = []) => {
  const [
    sessionPerformance,
    setSessionPerformance
  ] = useSessionPerformanceParams();

  const filteredReport = useMemo(() => {
    // If no filters are selected, show all reports
    if (!sessionPerformance || sessionPerformance.length === 0) {
      return reports;
    }

    return reports.filter(report => {
      let included = false;
      const score = calculateOverallScore(report);

      // PROBLEM filter: "below 40%" - scores < 40
      if (sessionPerformance.includes(SESSION_FILTERS.PROBLEM.toString())) {
        if (score < SESSION_FILTERS_RANGE.MIN) {
          included = true;
        }
      }

      // OK filter: "40-70%" - scores >= 40 and <= 70 (inclusive on both ends)
      if (sessionPerformance.includes(SESSION_FILTERS.OK.toString())) {
        if (
          score >= SESSION_FILTERS_RANGE.MIN &&
          score <= SESSION_FILTERS_RANGE.MAX
        ) {
          included = true;
        }
      }

      // GOOD filter: "above 70%" - scores > 70
      if (sessionPerformance.includes(SESSION_FILTERS.GOOD.toString())) {
        if (score > SESSION_FILTERS_RANGE.MAX) {
          included = true;
        }
      }

      return included;
    });
  }, [reports, sessionPerformance]);

  return [filteredReport, sessionPerformance, setSessionPerformance];
};

export default useFilteredSessionReports;
